
namespace TabAurous.Reports {
     

    @Serenity.Decorators.registerClass()
    export class OpenConsignmentOutGrid extends Serenity.EntityGrid<TabAurous.Sales.ApprovalOutItemsRow, any> {
        protected getColumnsKey() { return 'Sales.OpenConsignmentOutItems'; }
        protected getDialogType() { return TabAurous.Sales.ApprovalOutItemsDialog; }
        protected getIdProperty() { return TabAurous.Sales.ApprovalOutItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Sales.ApprovalOutItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Sales.ApprovalOutItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Sales.OpenConsignmentOutService.baseUrl; }
         
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 100 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Sales/OpenConsignmentOut/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Customer',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            

            return filters; 
        }
  

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setGrouping([{

                getter: 'LedgerName',
                displayTotalsRow: false,
            }])
            return grid;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var self = this;
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: TabAurous.Sales.OpenConsignmentOutService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Sales.OpenConsignmentOutService.baseUrl + '/ExportExcelWithOutImages',
                        request: {
                            ProductIds: (self.view.params as ReportFiltersRequest).ProductIds,
                            ProductCodes: (self.view.params as ReportFiltersRequest).ProductCodes,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds,
                            LedgerNames: (self.view.params as ReportFiltersRequest).LedgerNames,
                            CompanyIds: (self.view.params as ReportFiltersRequest).CompanyIds,
                            FinancialYearIds: (self.view.params as ReportFiltersRequest).FinancialYearIds,
                        },

                        target: '_blank'
                    });
                }
            });
            buttons.push({
                title: 'Print With Images',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Sales.OpenConsignmentOutService.baseUrl + '/ExportExcelWithImages',
                        request: {
                            ProductIds: (self.view.params as ReportFiltersRequest).ProductIds,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds,
                            LedgerNames: (self.view.params as ReportFiltersRequest).LedgerNames
                        },

                        target: '_blank'
                    });
                }
            });
            //buttons.push(Common.PdfExportHelper.createToolButton({
            //    grid: this,
            //    title: "Print",
            //    reportTitle: "Open Sales Consignment ",
            //    onViewSubmit: () => this.onViewSubmit()
            //}));
            return buttons;
        }
    }
}